// Pixels-per-meter scale that fits a world-space bounding box into a
// canvas. Lives here rather than in UVFloorPlanCanvas so it can be
// unit-tested without the canvas's import graph (firebase, textures),
// and so both callers inside that component share one definition —
// without it the auto-fit and the minimap's focusRoom drifted, the
// former getting TIER_SLOTS-aware padding while the latter kept a
// hardcoded percent-of-canvas figure that over-zoomed small rooms.
import { TIER_SLOTS } from './floorPlanFixtureMeasurements';

const MEASUREMENT_LABEL_MARGIN_M = 0.35;
const VIEW_VISUAL_MARGIN_FACTOR = 0.92;

/**
 * @param {boolean} [showMeasurements=true] Whether measurement labels
 *   will actually be drawn. The padding exists solely to leave room for
 *   them, so reserving it when they are off shrinks the plan for labels
 *   that never appear — 1.5m on every side, which on a 2.4 x 3.0m
 *   bathroom padded the fit box to 5.4 x 6.0m and drew the room at
 *   under half the size it could be (the layout-generator preview
 *   cards, which pass `showMeasurements={false}`). Defaults true so a
 *   caller that doesn't say keeps the measurement-safe framing.
 * @returns {number|null} null when the bounds are degenerate.
 */
export const computeMeasurementAwareFitScale = (
  minX,
  maxX,
  minZ,
  maxZ,
  canvasW,
  canvasH,
  showMeasurements = true
) => {
  const measurementPaddingM = showMeasurements
    ? TIER_SLOTS[TIER_SLOTS.length - 1] + MEASUREMENT_LABEL_MARGIN_M
    : 0;
  const paddedW = maxX - minX + 2 * measurementPaddingM;
  const paddedH = maxZ - minZ + 2 * measurementPaddingM;
  if (paddedW <= 0 || paddedH <= 0) return null;
  const availW = canvasW * VIEW_VISUAL_MARGIN_FACTOR;
  const availH = canvasH * VIEW_VISUAL_MARGIN_FACTOR;
  return Math.min(availW / paddedW, availH / paddedH);
};
